import Ajax from "Utils/ajax";
export const vTigerReport = (data) => Ajax.post('vTiger/vTigerReport',data);
export const getvTigerUsers = (data) => Ajax.post('vTiger/getvTigerUsers',data);